import type { Tag } from './tag';

export class Filters {
  moods: Tag[];
  genres: Tag[];
  energyLevels: Tag[];
  instruments: Tag[];
  themes: Tag[];
  types: Tag[];
  categories: Tag[];
  minBpm: number;
  maxBpm: number;
  minLength: number;
  maxLength: number;
  orderBy: string;
  similarTo: number;
}

export const defaultFilters = {
  orderBy: 'date',
  minBpm: 0,
  maxBpm: 250,
  minLength: 0,
  maxLength: 10,
};
